import { render, staticRenderFns } from "./Research_pack.vue?vue&type=template&id=66cbadfa&scoped=true"
import script from "./Research_pack.vue?vue&type=script&lang=js"
export * from "./Research_pack.vue?vue&type=script&lang=js"
import style0 from "./Research_pack.vue?vue&type=style&index=0&id=66cbadfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cbadfa",
  null
  
)

export default component.exports